import React from 'react'
import {
  OptionsMenu,
  OptionsMenuItem,
  OptionsMenuTrigger,
} from '@deque/cauldron-react'
import { Icon } from '@deque/cauldron-react'
import { useTheme, setTheme } from '../../context/Theme'
import { useTranslation } from 'react-i18next'
import './index.scss'

export default function ThemeToggle() {
  const { state, dispatch } = useTheme()
  const { t } = useTranslation()

  const trigger = (props: React.HTMLAttributes<HTMLButtonElement>) => {
    return (
      <OptionsMenuTrigger {...props}>
        <Icon type="sun" label={t('theme.label')} />
        <Icon type="chevron-down" />
      </OptionsMenuTrigger>
    )
  }

  return (
    <OptionsMenu className="ThemeToggle" trigger={trigger}>
      <OptionsMenuItem key="light" onSelect={() => setTheme(dispatch, 'light')}>
        <span>{t('theme.light')}</span>
      </OptionsMenuItem>
      <OptionsMenuItem key="dark" onSelect={() => setTheme(dispatch, 'dark')}>
        <span>{t('theme.dark')}</span>
      </OptionsMenuItem>
    </OptionsMenu>
  )
}
